module.exports = __webpack_public_path__ + "static/media/neuter.bf80e5a6.svg";